const tablesSettings = {
    namespaced: true,

    state: {
        tableSettings: {
            perPage: localStorage.getItem('tableSettings.perPage') || 25,
        },
    },

    mutations: {
        SET_TABLE_SETTINGS : (state, payload) => {
            let setting = payload
            localStorage.setItem('tableSettings.' + setting.name, setting.value)
            state.tableSettings[setting.name] = setting.value
        }
    },

    getters: {
        tableSettings : state => {
            return state.tableSettings
        }
    },

    actions: {
        setTableSettings : (context, payload) => {
            context.commit('SET_TABLE_SETTINGS', payload)
        },
    }
}

export default {
    ...tablesSettings,
}
